import { Component, OnInit, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { OcorrenciaService } from 'src/app/services/ocorrencia.service';
import { CarregandoService } from 'src/app/services/carregando.service';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { PageEvent, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { Ocorrencia } from 'src/app/models/ocorrencia';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { GlobalService } from 'src/app/services/global.service';
import { PaginatorService } from 'src/app/services/paginator.service';

@Component({
  selector: 'app-selecionar-ocorrencia-modal',
  templateUrl: './selecionar-ocorrencia-modal.component.html',
  styleUrls: ['./selecionar-ocorrencia-modal.component.scss']
})
export class SelecionarOcorrenciaModalComponent implements OnInit {
  idCupom: string;
  ocorrencias: Ocorrencia[] = [];
  paginacao;
  campoOrdenacao = 'id';
  ordenarDesc = false;
  itensPorPagina;
  public config: PerfectScrollbarConfigInterface = {};
  listaDeItensPorPagina;
  integrador = false;

  constructor(
    private router: Router,
    private globalService: GlobalService,
    private ocorrenciaService: OcorrenciaService,
    private carregandoService: CarregandoService,
    private notificacaoService: NotificacaoService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<SelecionarOcorrenciaModalComponent>,
    private paginatorService: PaginatorService
  ) {
    this.idCupom = data.idCupom;
  }

  async ngOnInit() {
    const pagination = this.paginatorService.consultarPaginacao();

    this.paginacao = pagination.paginacao;
    this.itensPorPagina = pagination.itensPorPagina;
    this.listaDeItensPorPagina = pagination.listaDeItensPorPagina;
    this.integrador = await this.globalService.integrador();

    this.buscarOcorrencias();
  }

  retornaClasseStatus(status: number) {
    switch (status.toString()) {
      case '0':
        return 'badge-primary';
      case '1':
        return 'badge-info';
      case '2':
        return 'badge-success';
      default:
        return 'badge-info';
    }
  }

  retornaClasseEtapa(etapa: string) {
    if (!etapa) {
      return '';
    }
    return 'badge-secondary';
  }

  selecionaOcorrencia(ocorrencia: Ocorrencia) {
    if (this.integrador) {
      return;
    }
    else {
      this.router.navigate(['/controle-ocorrencia/lancamento'], {
        state: {
          veioDoModal: true,
          idOcorrencia: ocorrencia.id
        }
      });
      this.dialogRef.close();
    }
  }

  mudaDePagina(pageEvent: PageEvent) {
    if (this.itensPorPagina !== pageEvent.pageSize)
      this.paginatorService.salvaPaginacao(pageEvent.pageSize);

    this.itensPorPagina = pageEvent.pageSize;
    this.paginacao.paginaAtual = pageEvent.pageIndex + 1;

    this.buscarOcorrencias();
  }

  voltar() {
    this.dialogRef.close();
  }

  buscarOcorrencias() {
    this.carregandoService.mostra('buscarOcorrencias');

    this.ocorrenciaService.consultarComPaginacao(
      this.paginacao.paginaAtual,
      this.itensPorPagina,
      this.campoOrdenacao,
      this.ordenarDesc,
      this.idCupom,
    ).subscribe(
      (res: { itens: Ocorrencia[], total: number }) => {
        this.ocorrencias = res.itens;
        this.paginacao.total = res.total;
        this.carregandoService.esconde('buscarOcorrencias');
      },
      (err: Error) => {
        this.carregandoService.esconde('buscarOcorrencias');
        this.notificacaoService.erro(err);
      }
    );
  }

  criarOcorrencia() {
    this.router.navigateByUrl('/controle-ocorrencia/novo',
      {
        state: {
          idCupom: this.idCupom,
          veioDoModal: true
        }
      });
    this.dialogRef.close();
  }
}
